module.exports = __webpack_public_path__ + "static/media/landingPageVideoTop.c7a0669c.webp";